export function arePricesAndDiscountsDifferent(product, otherProduct) {
    return product && otherProduct &&
        (product.priceWT !== otherProduct.priceWT ||
            product.discount !== otherProduct.discount ||
            product.discount !== otherProduct.discount ||
            product.discountedPriceWT !== otherProduct.discountedPriceWT);
}